export const Types = {
    START_FIND_INTERVIEW_STATUS: 'START_FIND_INTERVIEW_STATUS',
    END_FIND_INTERVIEW_STATUS: 'END_FIND_INTERVIEW_STATUS',

    START_CREATE_INTERVIEW_STATUS: 'START_CREATE_INTERVIEW_STATUS',
    END_CREATE_INTERVIEW_STATUS: 'END_CREATE_INTERVIEW_STATUS',
  };
  